// extracted by mini-css-extract-plugin
module.exports = {"contract":"Consent_contract__2ZpLH"};